import { createI18n } from 'vue-i18n'
import enUS from './enUS'
import zhCN from './zhCN'

const defaultLocale = localStorage.getItem('locale') || 'enUS'

const i18n = createI18n({
  legacy: false,
  locale: defaultLocale,
  fallbackLocale: 'enUS',
  messages: {
    enUS,
    zhCN,
  },
})

export function setLocale(locale: string) {
  i18n.global.locale.value = locale as 'enUS' | 'zhCN'
  localStorage.setItem('locale', locale)
}

export const getLocale = (): string => {
  return i18n.global.locale.value as string
}

export default i18n
